import { observer } from "mobx-react";

import { Popup } from "components/Popup/Popup";
import Button from "components/UI/Button/Button";

import popupStore from "components/Popup/PopupStore";

import "./LegalInformation.scss";

const informationList = {
  items: [ 
    <p><b>Яндекс, Яндекс.Карты, Яндекс.Маркет и Яндекс.Музыка </b>являются зарегистрированными товарными знаками ООО «Яндекс». Платформа Boostclick не связана с компанией Яндекс и не действует от ее имени.</p>,
    <p><b>Google и Google Maps </b>являются товарными знаками компании Google LLC. Мы не связаны с Google и не предоставляем услуги от ее имени</p>,
    <p><b>Ozon и логотип Ozon </b>являются зарегистрированными товарными знаками ООО «Интернет Решения». Boostclick не является партнером Ozon</p>,
    <p><b>Wildberries </b>является товарным знаком ООО «Вайлдберриз». Мы не аффилированы с Wildberries и не имеем официального сотрудничества</p>,
    <p><b>VK, VK Музыка и ВКонтакте </b>являются товарными знаками VK Company Limited. Boostclick действует независимо и не аффилирован с VK</p>,
    <p><b>Telegram </b>является товарным знаком Telegram Messenger Inc. Платформа Boostclick не имеет официальной связи с Telegram</p>,
    <p><b>Аптека.ру </b>зарегистрированный товарный знак. Мы не представляем эту компанию</p>,
    <p><b>МегаМаркет </b>товарный знак АО «СберМегаМаркет». Boostclick не сотрудничает с этой платформой напрямую</p>,
  ],
};

export const LegalInformation = observer(() => {
  return (
    <Popup modalType={`legal-info-modal`} title="Правовая информация">
      <ol className="legal-info-modal__list">{informationList.items.map((item, index) => <li key={index}>{item}</li>)}</ol>
      <div className="legal-info-modal__border" />
      <Button title="Ок" onClick={() => popupStore.close()} />
    </Popup>
  );
});

export default LegalInformation;
